function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css, keyframes } from '@emotion/react';
import IconSpinner3 from '~icons/ei/spinner-3';
import { theme } from '@arc/frontend/ui-theme';
const spinning = keyframes({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
const fadeIn = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
const styles = {
  container: process.env.NODE_ENV === "production" ? {
    name: "10t20vi",
    styles: "display:flex;align-items:center;justify-content:space-around;width:100%;height:100%;overflow:hidden"
  } : {
    name: "vzm9ku-container",
    styles: "display:flex;align-items:center;justify-content:space-around;width:100%;height:100%;overflow:hidden;label:container;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  containerInline: process.env.NODE_ENV === "production" ? {
    name: "1saok50",
    styles: "display:inline-block;vertical-align:middle"
  } : {
    name: "lega5k-containerInline",
    styles: "display:inline-block;vertical-align:middle;label:containerInline;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  spinner: /*#__PURE__*/css({
    width: '100%',
    height: '100%',
    maxWidth: '4rem',
    maxHeight: '4rem',
    color: theme.colors.text.hint,
    animation: `${spinning} 1.2s linear infinite, ${fadeIn} 0.3s both`
  }, process.env.NODE_ENV === "production" ? "" : ";label:spinner;"),
  spinnerImmediate: /*#__PURE__*/css({
    animation: `${spinning} 1.2s linear infinite`
  }, process.env.NODE_ENV === "production" ? "" : ";label:spinnerImmediate;")
};
/** Display a loading spinner in the center of the container. */
export function LoadingIndicator({
  immediate = false,
  color,
  className
}) {
  return <div css={styles.container} className={className} data-testid="loading-spinner">
			<IconSpinner3 css={[styles.spinner, immediate ? styles.spinnerImmediate : undefined, color ? {
      color
    } : undefined, process.env.NODE_ENV === "production" ? "" : ";label:LoadingIndicator;"]} />
		</div>;
}

/** Display a loading spinner inline with some text. */
export function LoadingIndicatorInline({
  immediate = false,
  color,
  className
}) {
  return <span css={styles.containerInline} className={className} data-testid="loading-spinner">
			<IconSpinner3 css={[styles.spinner, immediate ? styles.spinnerImmediate : undefined, color ? {
      color
    } : undefined, process.env.NODE_ENV === "production" ? "" : ";label:LoadingIndicatorInline;"]} />
		</span>;
}